import { Context, useContext } from "react";

/**
 * Same as useContext but will error if the context value is not defined. This usually means a context
 * provider is missing.
 *
 * In development mode during hot reloading, it will return undefined instead of throwing to prevent
 * disruptive errors.
 */
const useContextSafe = <T>(SomeContext: Context<T | undefined>): T => {
  const context = useContext(SomeContext);

  if (!context) {
    // In development, return undefined during hot reloading instead of throwing
    if (process.env.NODE_ENV === "development") {
      return {} as T;
    }
    throw new Error(`${SomeContext.displayName || "Unknown context"} must be used within a provider`);
  }
  return context;
};

export default useContextSafe;
